import { IxLookupFilterDTO } from 'ix-ng-components';
import { Maybe } from 'ix-ng-static-utils';

export class UkrepLookupDTO {
  siUkrepId: Maybe<number> = null;
  koda: Maybe<string> = null;
  poglavjeKoda: Maybe<string> = null;
  naziv: Maybe<string> = null;
  nazivAng: Maybe<string> = null;
  poglavjeNaziv: Maybe<string> = null;
  poglavjeNazivAng: Maybe<string> = null;
  opis: Maybe<string> = null;
  opisAng: Maybe<string> = null;
  displayField: Maybe<string> = null;
}

export class UkrepLookupFilterDTO extends IxLookupFilterDTO<number> {
  prikaziAktivne: Maybe<boolean> = null;
}
